<template>
  <div>
    <question-option-input
      :read-only="true"
      placeholder="Date"
    />
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import QuestionOptionInput from './QuestionOptionInput.vue';

export default defineComponent({
  name: 'OptionDate',
  components: {
    QuestionOptionInput,
  },
});
</script>
